import MyFiles from "./MyFiles-container";

export default MyFiles;